document.addEventListener('DOMContentLoaded', () => {

  const form = document.getElementById('newsletter-form');
  if (!form) return;

  const message = form.querySelector('.newsletter-message');
  const thanks = form.querySelector('.newsletter-thanks');
  const container = form.querySelector('.container');
  const submitBtn = form.querySelector('[type="submit"]');

  const ENDPOINT = 'https://app.getresponse.com/add_subscriber.html';
  const CAMPAIGN_TOKEN = form.getAttribute('data-campaign-token');

  const isValidEmail = email =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  let isSubmitting = false;

  form.addEventListener('submit', async e => {
    e.preventDefault();

    if (isSubmitting) return;
    isSubmitting = true;
    submitBtn.disabled = true;

    const formData = new FormData(form);

    const name = (formData.get('name') || '').trim();
    const email = (formData.get('email') || '').trim();

    message.hidden = false;

    if (!email || !isValidEmail(email)) {
      message.textContent = 'Podaj poprawny adres e-mail.';
      message.className = 'newsletter-message error';

      isSubmitting = false;
      submitBtn.disabled = false;
      return;
    }

    const data = new URLSearchParams({
      name,
      email,
      campaign_token: CAMPAIGN_TOKEN,
      start_day: 0
    });

    try {
      await fetch(ENDPOINT, {
        method: 'POST',
        body: data,
        mode: 'no-cors'
      });

      // ✅ SUKCES
      message.hidden = true;
      container.hidden = true;

      // Poprawnie pokazujemy thanks
      thanks.hidden = false;
      // lub: thanks.classList.remove('hidden');

    } catch (err) {
      message.textContent = 'Wystąpił błąd. Spróbuj ponownie.';
      message.className = 'newsletter-message error';

      isSubmitting = false;
      submitBtn.disabled = false;
    }
  });

});
